import Message from "../../message";
import {useMainStore} from "@/store";

export default class GuildVipPointsGained extends Message
{
    handle()
    {
        useMainStore().INCREMENT_GUILD_VIP_POINTS(this.message.points);
    }
}
